import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {

  $(document).ready(function(){
    if(window.location.hash) {
      var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
      // hash found
      if($('#'+hash).length){
        $('#'+hash).find('.accordion__title').click();
      } 
    }
  });

	const $acc = $('.accordion');

	$acc.each(function () {
		const $e = $(this);
		const $title = $(this).find('.accordion__title');
		const $content = $(this).find('.accordion__content');

		$title.on('click', function () {
      $e.toggleClass('accordion--open');
      $(document).trigger('accordion-opened');
			$content.slideToggle();
		});
	});
  
	
	$(document).on('click', '.js-accordeon-trigger', function () {
		var $title = $(this).parent().find('.ns-accordeon__title');
		var $content = $(this).parent().find('.ns-accordeon__content');

		$title.toggleClass('active');

		if ($title.hasClass('active')) {
			$content.animate({
				height: $content.get(0).scrollHeight
			}, 200, function () {
				$(this).height('auto');
			});
		}
		else {
			$content.animate({
				height: 0
			}, 200, function () {
				$(this).height('0');
			});
    }

	});
	
})(jQuery);